import React, { useEffect, useState } from 'react';

import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { BaseModal } from 'components/UI';
import { useHistory } from 'react-router-dom';
import { usersActions } from 'state/modules/users';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';

const ConfirmActionModal = ({ id, open, type, handleClick }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [content, setContent] = useState(null);
  const { fetchingDeleteUser, fetchedDeleteUserSuccess, message } = useSelector(
    (state) => state.users
  );

  useEffect(() => {
    if (fetchedDeleteUserSuccess) {
      handleClick();
      dispatch(usersActions.resetDeleteUser());
      history.push(buildUrl('/customers'));
    }
  }, [fetchedDeleteUserSuccess, handleClick, dispatch, history, type]);

  useEffect(() => {
    if (message) {
      setContent(message);
    }
  }, [fetchedDeleteUserSuccess, handleClick, dispatch, history, type]);

  /**
   * Handle delete user
   * @param {object} values Object with the value of fields of the form
   */
  const handleDeleteUser = () => {
    dispatch(usersActions.fetchDeleteUser(id, type, { confirm: true }));
  };

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      onEnter={handleDeleteUser}
      loading={fetchingDeleteUser}
      enterButtonLabel={i18n.t('common.confirm')}
      title={i18n.t('customers.confirm_delete_title')}
      privileges={{ action: 'delete', subject: 'user' }}
    >
      <Box width="100%">
        <Typography variant="inherit">{content}</Typography>
      </Box>
    </BaseModal>
  );
};

ConfirmActionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['user', 'customer']),
};

ConfirmActionModal.defaultProps = {
  open: false,
  type: 'user',
  handleClick: () => {},
};

export default ConfirmActionModal;
